export const categoryMeta = {
  movie: {
    slug: "movie",
    name: "电影",
    title: "电影 - 91看片｜优质影视资源在线观看平台",
    description: "91看片电影频道汇集动作、科幻、喜剧、悬疑等热门类型的高清电影资源，支持按类型、年份、地区与标签筛选，快速发现优质影片。",
    intro: "汇聚全球院线与经典佳作，涵盖动作、科幻、悬疑、文艺等多种类型，支持多条件筛选，帮你在海量片单里精准找到今晚想看的那一部。",
    filterLabels: ["类型", "年份", "地区", "热门标签"],
  },
  tv: {
    slug: "tv",
    name: "电视剧",
    title: "电视剧 - 91看片｜优质影视资源在线观看平台",
    description: "91看片电视剧频道提供国产剧、韩剧、日剧等热门剧集资源，可按类型、年份、地区与更新状态筛选，连载与完结一目了然。",
    intro: "从国产古装大剧到海外热门剧集，连载、完结状态清晰标注，可按类型、地区与更新时间筛选，追剧不再迷路。",
    filterLabels: ["类型", "年份", "地区", "更新状态"],
  },
  variety: {
    slug: "variety",
    name: "综艺",
    title: "综艺 - 91看片｜优质影视资源在线观看平台",
    description: "91看片综艺频道收录真人秀、音乐、竞技、访谈等热门综艺节目，支持按节目类型、播出平台与年份筛选，轻松找到想看的节目。",
    intro: "真人秀、音乐竞演、脱口秀、美食纪实一网打尽，可按节目类型、播出平台与年份筛选，随时追上最新一期。",
    filterLabels: ["节目类型", "播出平台", "年份"],
  },
};

export default categoryMeta;